// 3rd Party
import PropTypes from 'prop-types';
import React from 'react';

// Component
const InsuranceUmbrellaSvg = ({ color, height, width }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 40 35"
    role="presentation"
  >
    <path
      fill={color}
      fillRule="evenodd"
      d="M38.696 28.322c3.222-9.403-.32-19.745-8.367-24.923l.658-1.142a1.012 1.012 0 00-.362-1.35 1.012 1.012 0 00-1.35.36l-.66 1.142C19.825-2.133 8.69-.115 2.28 7.297c-.443.504-.635 1.23-.41 1.894.122.452.423.854.88 1.117.17.1.285.165.49.207.203.042.464.116.726.19.555.093 1.34.318 1.682.515 2.397 1.383 3.95 3.573 4.183 6.068.054.564.403 1.146.973 1.476.57.33 1.25.34 1.766.106 2.03-.882 4.27-.807 6.457.15l-4.878 8.45c-.68-.012-1.35.36-1.714.99a4.586 4.586 0 01-6.302 1.688c-1.142-.66-1.987-1.832-2.235-3.117a1.92 1.92 0 00-2.3-1.554 1.919 1.919 0 00-1.555 2.298c.472 2.48 2 4.58 4.168 5.83a8.55 8.55 0 0011.705-3.135c.363-.63.35-1.397 0-1.98l4.878-8.447c1.923 1.414 3.108 3.316 3.36 5.517-.002.53.347 1.113.918 1.443.57.33 1.25.34 1.765.106 2.243-.99 4.95-.797 7.29.554.113.066.357.435.552.624l.83.936c.114.066.195.19.31.255.456.262 1.012.355 1.495.177.663-.226 1.164-.698 1.38-1.335zM6.634 9.507c-.8-.46-2.057-.655-2.898-.912C9.513 1.885 19.568.155 27.424 4.08c-1.67.255-5.148 1.14-9.03 4.302-3.814 3.05-5.888 6.114-6.777 7.655-.634-2.726-2.357-5.014-4.983-6.53zm14.27 8.24c-2.625-1.517-5.526-1.898-8.146-1.05.824-1.428 2.832-4.38 6.524-7.346 4.037-3.3 7.678-3.938 8.897-4.072.493 1.122 1.704 4.56.863 9.708-.748 4.59-2.3 7.806-3.066 9.265-.667-2.667-2.447-4.988-5.073-6.504zm14.27 8.238c-2.625-1.516-5.526-1.897-8.145-1.05.888-1.54 2.506-4.87 3.238-9.698.8-4.943-.175-8.397-.79-9.97 7.272 4.807 10.165 14.165 7.365 22.442-.448-.412-1.097-1.396-1.668-1.725z"
    />
  </svg>
);
InsuranceUmbrellaSvg.propTypes = {
  color: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string,
};

export default InsuranceUmbrellaSvg;
